import type { ClientConfig } from '../../model/clientConfig.types'
import { layoutConfig } from './layout'
import clientLogo from './logo.default.svg'
import { defaultTheme } from './theme'

export const defaultConfig: ClientConfig = {
  theme: defaultTheme,
  name: 'default',
  logo: clientLogo,
  layout: layoutConfig,
}
